import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  main: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px 12px 0 0',
    marginTop: '20px',
    padding: theme.spacing(3),
    minWidth: "600px",
    maxWidth: "768px",
    "@media(max-width: 1024px)": {
      minWidth: "500px",
      maxWidth: "700px",
    },
    "@media(max-width: 768px)": {
      padding: theme.spacing(1),
      minWidth: "350px",
      maxWidth: "500px",
    },
    "@media(max-width: 500px)": {
      padding: theme.spacing(2),
      minWidth: "100%"
    },
  },
}));

export default function ResponsiveContainer({ children }) {
  const classes = useStyles();

  return (
    <div className={classes.main}>
      {children}
    </div>
  );
}
